export const routerPaths = {
  auth: {
    login: '/login',
    loginAdministrador: '/login-administrador',
    esqueceuSenha: '/esqueceu-senha',
    esqueceuSenhaToken: '/esqueceu-senha/:token',
    sso: '/sso',
    forgotSso: '/forgot-sso',
    cadastro: '/cadastro',
    notAuthorized: '/misc/not-authorized',
    error: '/misc/error',
    commingSoon: '/comming-soon'
  },
  app: {
    home: '/home',
    cadastros: {
      empresa: '/cadastros/empresa',
      usuarios: '/cadastros/usuarios',
      credenciais: '/cadastros/credenciais',
      pacientes: '/cadastros/pacientes',
      profissionaisExecutantes: '/cadastros/profissionais-executantes',
      tabelasPrecos: '/cadastros/tabelas-de-precos',
      unidadesAtendimento: '/cadastros/unidades-de-atendimento'
    },
    autorizacao: '/autorizacao',
    execucao: '/execucao',
    pedidoExame: '/pedido-exame',
    historico: '/historico',
    pendencias: '/pendencias',
    relatorios: '/relatorios',
    faturamento: '/faturamento',
    monitor: '/monitor',
    perfil: '/perfil',
    enviarAnexo: '/anexos-upload/:token/:credencialId',
    enviarPedido: '/enviar-pedido/:token',
    validarBiometria: '/validar-biometria',
    assinarGuia: '/assinar-guia/:pedidoAssinaturaId',
    assinarSessao: '/assinar-sessao/:pedidoId',
    validarRecibo: '/validar-recibo/:pedidoExameId',
    ivia: '/ivia',
    anexoGuia: '/anexo-guia',
    biometriaGuia: '/biometria-guia',
    tokenGuia: '/token-guia',
    assinaturaGuia: '/assinatura-guia',
    ativacaoBiometria: '/ativacao-biometria',
    tokenPaciente: '/token-paciente',
    cadastroPaciente: '/cadastro-paciente'
  }
}

export const isAuthenticatedRoute = (currentPath = window.location.pathname) => {
  const unauthenticatedRoutes = [
    routerPaths.auth.login,
    routerPaths.auth.loginAdministrador,
    routerPaths.auth.esqueceuSenha,
    routerPaths.auth.esqueceuSenhaToken,
    routerPaths.auth.sso,
    routerPaths.auth.forgotSso,
    routerPaths.auth.cadastro,
    routerPaths.auth.notAuthorized,
    routerPaths.auth.error,
    routerPaths.auth.commingSoon,
    routerPaths.app.enviarPedido,
    routerPaths.app.enviarAnexo,
    routerPaths.app.assinarGuia,
    routerPaths.app.assinarSessao,
    routerPaths.app.validarRecibo
  ]

  const isUnauthenticated = unauthenticatedRoutes.some(route => {
    if (currentPath === route) return true

    if (route.includes('/:')) {
      const baseRoute = route.split('/:')[0]
      return currentPath.startsWith(baseRoute)
    }

    return false
  })

  return !isUnauthenticated
}
